export enum TooltipTextPosition {
  MIDDLE_BOTTOM = "middle-bottom",
  BOTTOM_RIGHT = "bottom-right",
}
